import { computed } from "vue";
import { isLuxuryMerchantId, parseLuxuryMerchants } from "~/utils/luxury.utils";

export const useLuxuryDesign = () => {
  const {
    public: { luxuryMerchant },
  } = useRuntimeConfig();

  const luxuryMerchants = computed(() => parseLuxuryMerchants(luxuryMerchant));

  const isLuxuryMerchant = (merchantId?: string | null) =>
    isLuxuryMerchantId(merchantId ?? null, luxuryMerchants.value);

  const getMerchantDesign = (merchantId?: string | null) =>
    isLuxuryMerchant(merchantId) ? "luxury" : "standard";

  const getMerchantAttributes = (merchantId?: string | null) => {
    const merchant = merchantId ?? "";
    return {
      "data-merchant-id": merchant,
      "data-merchant-design": getMerchantDesign(merchant),
    } as const;
  };

  return {
    luxuryMerchants,
    isLuxuryMerchant,
    getMerchantDesign,
    getMerchantAttributes,
  };
};
